import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: undefined,
  },
  showBreadcrumbs: Boolean,
  hideTitle: Boolean,
  leftSidebarWidth: {
    type: [String, Number],
    default: '60',
  },
  rightSidebarWidth: {
    type: [String, Number],
    default: '60',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_c_page_left_sidebar = _resolveComponent("c-page-left-sidebar")!
  const _component_c_page_title = _resolveComponent("c-page-title")!
  const _component_c_page_auto_breadcrumbs = _resolveComponent("c-page-auto-breadcrumbs")!
  const _component_c_page_main_content = _resolveComponent("c-page-main-content")!
  const _component_c_page_flex_col = _resolveComponent("c-page-flex-col")!
  const _component_c_page_outer_wrapper = _resolveComponent("c-page-outer-wrapper")!
  const _component_c_page_right_sidebar = _resolveComponent("c-page-right-sidebar")!
  const _component_c_page_blank = _resolveComponent("c-page-blank")!

  return (_openBlock(), _createBlock(_component_c_page_blank, { class: "border-t" }, {
    default: _withCtx(() => [
      _createVNode(_component_c_page_flex_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_c_page_outer_wrapper, null, {
            default: _withCtx(() => [
              _createVNode(_component_c_page_left_sidebar, {
                style: _normalizeStyle({ width: __props.leftSidebarWidth + 'px' })
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "left-sidebar")
                ]),
                _: 3
              }, 8, ["style"]),
              _createVNode(_component_c_page_flex_col, null, {
                default: _withCtx(() => [
                  (!__props.hideTitle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_c_page_title, { title: __props.title }, null, 8, ["title"])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.showBreadcrumbs)
                    ? (_openBlock(), _createBlock(_component_c_page_auto_breadcrumbs, { key: 1 }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_c_page_main_content, null, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(_component_c_page_right_sidebar, {
        style: _normalizeStyle({ width: __props.rightSidebarWidth + 'px' })
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "right-sidebar")
        ]),
        _: 3
      }, 8, ["style"])
    ]),
    _: 3
  }))
}
}

})